import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, ListGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";
const Cart = ({ cartItems }) => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    country: 'India',
    streetAddress: '',
    apartment: '',
    town: '',
    state: '',
    postcode: '',
    phone: '',
    email: '',
    createAccount: false,
  });

  const [isFormValid, setIsFormValid] = useState(false);

  const cityOptions = [
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Ahmedabad', label: 'Ahmedabad' },
    { value: 'Surat', label: 'Surat' },
    { value: 'Jaipur', label: 'Jaipur' },
    { value: 'Lucknow', label: 'Lucknow' },
    { value: 'Kanpur', label: 'Kanpur' },
    { value: 'Indore', label: 'Indore' },
    { value: 'Nagpur', label: 'Nagpur' },
    { value: 'Chandigarh', label: 'Chandigarh' },
    { value: 'Vadodara', label: 'Vadodara' },
    { value: 'Coimbatore', label: 'Coimbatore' },
    { value: 'Patna', label: 'Patna' },
    { value: 'Bhopal', label: 'Bhopal' },
    { value: 'Mysore', label: 'Mysore' },
    { value: 'Visakhapatnam', label: 'Visakhapatnam' },
    { value: 'Madurai', label: 'Madurai' },
    { value: 'Nashik', label: 'Nashik' },
    { value: 'Faridabad', label: 'Faridabad' },
    { value: 'Ludhiana', label: 'Ludhiana' },
    { value: 'Rajkot', label: 'Rajkot' },
    { value: 'Gurugram', label: 'Gurugram' },
  ];  
 

  useEffect(() => {
    validateForm();
  }, [formData]);

  const validateForm = () => {
    const { firstName, lastName, streetAddress, town, state, postcode, phone, email } = formData;
    const isValid = firstName && lastName && streetAddress && town && state && postcode && phone && email;
    setIsFormValid(!!isValid);
  };  

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: type === 'checkbox' ? checked : value };
      validateForm(updatedData); // ✅ validate with updated data
      return updatedData;
    });
  };
  
  const handleCityChange = (selectedOption) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, town: selectedOption.value };
      validateForm(updatedData); // ✅ validate with updated data
      return updatedData;
    });
  };
  

  const handleProceedToPayment = () => {
    if (!isFormValid) {
      setErrorMessage('Please fill in all required fields before proceeding to payment.');
      return;
    }
    setErrorMessage(''); // Clear any previous message
    navigate('/payment', {
      state: { cartItems, formData },
    });
  };
  

  // Calculate total cost
  const totalCost = cartItems.reduce((total, item) => {
    const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ""));
    return total + (isNaN(price) ? 0 : price);
  }, 0).toFixed(2);

  return (
    <Container className="mt-5">
      <Row>
        {/* Billing Details Form - Left Side */}
        <Col md={6}>
          <h3>Billing Details</h3>
          <Form>
            {/* First Name */}
            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter your first name" 
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Last Name */}
            <Form.Group className="mb-3" controlId="formLastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter your last name" 
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Country/Region */}
            <Form.Group className="mb-3" controlId="formCountry">
              <Form.Label>Country / Region</Form.Label>
              <Form.Control 
                type="text" 
                value={formData.country}
                readOnly
              />
            </Form.Group>

            {/* Street Address */}
            <Form.Group className="mb-3" controlId="formStreetAddress">
              <Form.Label>Street address</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter street address" 
                name="streetAddress"
                value={formData.streetAddress}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Town / City */}
            <Form.Group className="mb-3" controlId="formTown">
              <Form.Label>Town / City</Form.Label>
              <Select
                options={cityOptions}
                name="town"
                value={cityOptions.find(option => option.value === formData.town)}
                onChange={handleCityChange}
              />
            </Form.Group>

            {/* State */}
            <Form.Group className="mb-3" controlId="formState">
              <Form.Label>State</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter state" 
                name="state"
                value={formData.state}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Postcode / ZIP */}
            <Form.Group className="mb-3" controlId="formPostcode">
              <Form.Label>Postcode / ZIP</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter postcode" 
                name="postcode"
                value={formData.postcode}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Phone Number */}
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter phone number" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Email Address */}
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                type="email" 
                placeholder="Enter email address" 
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Create an Account Checkbox */}
            <Form.Group className="mb-3" controlId="formCreateAccount">
              <Form.Check 
                type="checkbox" 
                label="Create an account?" 
                name="createAccount"
                checked={formData.createAccount}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Col>

        {/* Order Summary - Right Side */}
        <Col md={6}>
          <h3>Order Summary</h3>
          <ListGroup>
            {cartItems.map((item, index) => (
              <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                <div>
                  <img src={item.img} alt={item.name} style={{ width: 50, height: 50, objectFit: 'cover' }} />
                  <span className="ms-3">{item.name}</span>
                </div>
                <span>{item.price}</span>
              </ListGroup.Item>
            ))}
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <strong>Total</strong>
              <strong>₹{totalCost}</strong>
            </ListGroup.Item>
          </ListGroup>

          {errorMessage && (
            <div className="text-danger mt-3 text-center">
              {errorMessage}
            </div>
          )}
          <Button 
            variant="success" 
            className="mt-3 w-100" 
            onClick={handleProceedToPayment}
          >
            Proceed to Payment
          </Button>
        </Col>
      </Row>
        <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
                            <Container>
                              <Row className="text-center text-md-start">
                                {/* Left Column */}
                                <Col md={4} className="mb-4 mb-md-0">
                                  <img
                                    src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
                                    alt="Mati Haat"
                                    style={{ width: "130px", marginBottom: "20px" }}
                                  />
                                  <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                                    <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
                                    <div>
                                      <p className="mb-0">Got Questions? Call us 24/7!</p>
                                      <strong>+91 9654870373</strong>
                                    </div>
                                  </div>
                                  <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
                                    <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                                    <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                                    <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                                  </div>
                                </Col>
                      
                                {/* Middle Column - Quick Links */}
                                <Col md={4} className="mb-4 mb-md-0">
                                  <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
                                  <ul className="list-unstyled">
                                    <ul className="list-unstyled">
                                      <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                                      <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
                                     
                                      
                                      
                                      <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
                                    </ul>
                                  </ul>
                                </Col>
                      
                                {/* Right Column - Customer Care */}
                                <Col md={4}>
                                  <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
                                  <ul className="list-unstyled">
                                    <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
                                    <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
                                    <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
                                    <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
                                    <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
                                  </ul>
                                </Col>
                              </Row>
                            </Container>
                          </footer>
    </Container>
  );
};

export default Cart;
